import {
  CLINIC_NAME,
  CLINIC_STATE,
  LAUNCH_YEAR,
  EMAIL,
  PHONE,
  PHONE_DISPLAY,
  ADDRESS_SHORT,
  HOURS_SUMMARY,
  INSTAGRAM_URL,
  WHATSAPP_URL,
  FACEBOOK_URL,
} from '../constants';

export default function Footer({ onNav }) {
  const go = (id) => { onNav(id); window.scrollTo({ top: 0, behavior: 'smooth' }); };
  return (
    <>
      <style>{`
        .ft { background: var(--charcoal); padding: 52px 0 28px; }
        .ft-grid {
          display: grid; grid-template-columns: 2fr 1fr 1fr 1.4fr;
          gap: 40px; margin-bottom: 40px;
        }
        .ft-logo { display: flex; align-items: center; gap: 10px; margin-bottom: 14px; cursor: pointer; }
        .ft-logo-name {
          font-family: var(--font-display); font-size: 20px; font-weight: 600;
          color: var(--white); letter-spacing: 0.01em;
        }
        /* Coral accent on dark navy for readability. */
        .ft-logo-sub {
          font-size: 9px; letter-spacing: 0.16em; text-transform: uppercase;
          color: var(--accent); font-weight: 600; display: block; margin-top: 2px;
        }
        .ft-tagline { font-size: 13px; color: rgba(255,255,255,0.65); line-height: 1.7; margin-bottom: 18px; }
        .ft-social { display: flex; gap: 8px; }
        .ft-soc {
          width: 32px; height: 32px; border-radius: 6px;
          border: 1px solid rgba(255,255,255,0.18);
          display: flex; align-items: center; justify-content: center;
          font-size: 13px; color: rgba(255,255,255,0.75);
          cursor: pointer; transition: all 0.2s;
          text-decoration: none;
        }
        .ft-soc:hover {
          border-color: var(--accent);
          color: var(--accent);
          background: rgba(238,121,96,0.08);
        }
        /* Column headings — coral so they stand out on the navy footer. */
        .ft-col-title {
          font-size: 11px; letter-spacing: 0.16em; text-transform: uppercase;
          color: var(--accent); font-weight: 600; margin-bottom: 14px;
        }
        .ft-links { display: flex; flex-direction: column; gap: 9px; }
        .ft-lnk {
          font-size: 13px; color: rgba(255,255,255,0.7);
          cursor: pointer; background: none; border: none;
          font-family: var(--font-body); text-align: left; transition: color 0.15s;
          padding: 0; text-decoration: none;
        }
        .ft-lnk:hover { color: var(--white); }
        .ft-ci { display: flex; gap: 10px; margin-bottom: 12px; align-items: flex-start; }
        .ft-ci-icon {
          width: 26px; height: 26px; border-radius: 5px;
          background: rgba(238,121,96,0.15);
          display: flex; align-items: center; justify-content: center;
          font-size: 12px; flex-shrink: 0; margin-top: 1px;
        }
        /* Sub-labels in coral too — same readability fix. */
        .ft-ci-lbl {
          font-size: 10px; letter-spacing: 0.12em; text-transform: uppercase;
          color: var(--accent); display: block; margin-bottom: 2px; font-weight: 600;
        }
        .ft-ci-val {
          font-size: 12.5px; color: rgba(255,255,255,0.78); line-height: 1.5;
          text-decoration: none;
        }
        a.ft-ci-val:hover { color: var(--white); }
        .ft-div { border: none; border-top: 1px solid rgba(255,255,255,0.08); margin-bottom: 20px; }
        .ft-bottom {
          display: flex; justify-content: space-between; align-items: center;
          flex-wrap: wrap; gap: 10px;
        }
        .ft-copy { font-size: 12px; color: rgba(255,255,255,0.45); }
        /* Launch badge — coral, fully opaque so it actually reads. */
        .ft-badge {
          font-size: 11px; color: var(--accent); letter-spacing: 0.1em;
          text-transform: uppercase; font-weight: 600;
        }
        @media (max-width: 900px) { .ft-grid { grid-template-columns: 1fr 1fr; } }
        @media (max-width: 520px) {
          .ft-grid { grid-template-columns: 1fr; gap: 28px; }
          .ft-bottom { flex-direction: column; align-items: flex-start; }
        }
      `}</style>

      <footer className="ft">
        <div className="container">
          <div className="ft-grid">
            <div>
              <div className="ft-logo" onClick={() => go('home')}>
                <svg width="32" height="32" viewBox="0 0 38 38" fill="none">
                  <rect width="38" height="38" rx="9" fill="#1e3a5f"/>
                  <rect x="15" y="8" width="8" height="22" rx="3" fill="white"/>
                  <rect x="8" y="15" width="22" height="8" rx="3" fill="white"/>
                </svg>
                <div>
                  <div className="ft-logo-name">{CLINIC_NAME}</div>
                  <span className="ft-logo-sub">Excellence in Healthcare</span>
                </div>
              </div>
              <p className="ft-tagline">A premium polyclinic & medical co-working space. Bringing together experienced practitioners and quality care under one roof — Siddipet.</p>
              <div className="ft-social">
                <a className="ft-soc" href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" title="Instagram" aria-label="Instagram">ig</a>
                <a className="ft-soc" href={WHATSAPP_URL}  target="_blank" rel="noopener noreferrer" title="WhatsApp"  aria-label="WhatsApp">wa</a>
                <a className="ft-soc" href={FACEBOOK_URL}  target="_blank" rel="noopener noreferrer" title="Facebook"  aria-label="Facebook">fb</a>
              </div>
            </div>

            <div>
              <p className="ft-col-title">Navigate</p>
              <div className="ft-links">
                {[['home','Home'],['practitioners','For Practitioners'],['patients','For Patients'],['about','About Us'],['contact','Contact']].map(([id, label]) => (
                  <button key={id} className="ft-lnk" onClick={() => go(id)}>{label}</button>
                ))}
              </div>
            </div>

            <div>
              <p className="ft-col-title">Services</p>
              <div className="ft-links">
                {['General Medicine','Dental Care','Diagnostics','Pharmacy','Pediatrics','Cardiology','Orthopedics','Dermatology'].map(s => (
                  <span key={s} className="ft-lnk" style={{cursor:'default'}}>{s}</span>
                ))}
              </div>
            </div>

            <div>
              <p className="ft-col-title">Contact</p>
              <div className="ft-ci">
                <div className="ft-ci-icon">📍</div>
                <div>
                  <span className="ft-ci-lbl">Address</span>
                  <span className="ft-ci-val">{ADDRESS_SHORT}</span>
                </div>
              </div>
              <div className="ft-ci">
                <div className="ft-ci-icon">📞</div>
                <div>
                  <span className="ft-ci-lbl">Phone</span>
                  <a className="ft-ci-val" href={`tel:${PHONE}`}>{PHONE_DISPLAY}</a>
                </div>
              </div>
              <div className="ft-ci">
                <div className="ft-ci-icon">✉</div>
                <div>
                  <span className="ft-ci-lbl">Email</span>
                  <a className="ft-ci-val" href={`mailto:${EMAIL}`}>{EMAIL}</a>
                </div>
              </div>
              <div className="ft-ci">
                <div className="ft-ci-icon">🕐</div>
                <div>
                  <span className="ft-ci-lbl">Hours</span>
                  <span className="ft-ci-val">{HOURS_SUMMARY.weekday}<br />{HOURS_SUMMARY.sunday}</span>
                </div>
              </div>
            </div>
          </div>

          <hr className="ft-div" />
          <div className="ft-bottom">
            <span className="ft-copy">© {new Date().getFullYear()} {CLINIC_NAME}. All rights reserved.</span>
            <span className="ft-badge">Launching {LAUNCH_YEAR} · Siddipet, {CLINIC_STATE}</span>
          </div>
        </div>
      </footer>
    </>
  );
}
